import React from "react";

const Ktb = () => {
  return (
    <svg
      version="1.0"
      className="fill-[#DC0D15]"
      id="Layer_1"
      x="0px"
      y="0px"
      style={{ fill: "#DC0D15" }}
      viewBox="0 0 4842.7 3434.7"
    >
      <g>
        <path
          className="st0"
          d="M3433.4,2727h-52c-10,0-14.4-13.5-6.6-20.2l14.9-13c12.7-11,28.6-17,44.9-17h52c10,0,14.4,13.5,6.6,20.2
		l-14.9,12.9C3465.7,2721,3449.8,2727,3433.4,2727"
        />
        <path
          className="st0"
          d="M3501.5,2653.9l-51.9,3.6c-9.8,0.6-15.2-12.5-8-19.7l14.1-13.9c11.9-11.9,27.3-18.9,43.6-20l51.9-3.6
		c10-0.7,15.3,12.4,8,19.6l-14,13.9C3533.2,2645.7,3517.8,2652.7,3501.5,2653.9"
        />
        <path
          className="st0"
          d="M3564.2,2576.3l-51.6,7.3c-9.8,1.4-16.1-11.4-9.3-19.1l12.9-14.8c11.1-12.7,25.9-20.8,42.1-23l51.6-7.3
		c9.9-1.4,16.1,11.3,9.4,19l-13,14.9C3595.2,2565.9,3580.4,2574.1,3564.2,2576.3"
        />
        <path
          className="st0"
          d="M3621.4,2494.6l-51,10.7c-9.7,2.1-16.8-10.1-10.6-18.3l11.9-15.8c10.2-13.4,24.5-22.6,40.4-26l50.9-10.8
		c9.7-2.1,16.8,10.1,10.7,18.3l-12,15.8C3651.6,2481.9,3637.3,2491.1,3621.4,2494.6"
        />
        <path
          className="st0"
          d="M3672.6,2409l-49.9,14.3c-9.6,2.7-17.6-9-12-17.7l10.9-16.5c9.2-14.1,22.8-24.2,38.5-28.7l50-14.3
		c9.6-2.8,17.6,8.9,12,17.5l-10.9,16.5C3701.9,2394.4,3688.4,2404.5,3672.6,2409"
        />
        <path
          className="st0"
          d="M3717.8,2320l-48.8,17.7c-9.4,3.5-18.2-7.7-13.2-16.7l9.6-17.2c8.2-14.7,21-25.8,36.4-31.3l48.8-17.8
		c9.4-3.4,18.2,7.8,13.2,16.7l-9.7,17.3C3746.1,2303.4,3733.3,2314.4,3717.8,2320"
        />
        <path
          className="st0"
          d="M3756.8,2228.1l-47.5,21.2c-9.1,4.1-18.6-6.4-14.3-15.8l8.5-17.8c7.2-15.3,19.2-27.2,34.1-33.8l47.5-21.2
		c9.1-4,18.7,6.5,14.3,15.8l-8.5,17.9C3783.7,2209.6,3771.7,2221.5,3756.8,2228.1"
        />
        <path
          className="st0"
          d="M3789.2,2133.8l-46,24.4c-8.8,4.7-19-5.1-15.3-14.6l7.1-18.4c6.2-15.7,17.3-28.4,31.7-36.1l45.9-24.4
		c8.8-4.7,19,5.1,15.3,14.7l-7,18.4C3814.7,2113.4,3803.6,2126.2,3789.2,2133.8"
        />
        <path
          className="st0"
          d="M3814.9,2037.4l-44.1,27.6c-8.4,5.2-19.3-3.9-16.3-13.7l5.8-18.9c5-16.1,15.2-29.6,29.1-38.2l44.1-27.5
		c8.5-5.3,19.4,3.7,16.3,13.5l-5.8,18.8C3839.1,2015.3,3828.7,2028.8,3814.9,2037.4"
        />
        <path
          className="st0"
          d="M3833.8,1939.4l-42.1,30.6c-8.1,5.9-19.5-2.4-17.2-12.4l4.5-19.2c3.9-16.4,13.2-30.5,26.4-40.1l42.1-30.6
		c8.1-5.9,19.5,2.4,17.2,12.4l-4.6,19.2C3856.4,1915.7,3847,1929.8,3833.8,1939.4"
        />
        <path
          className="st0"
          d="M3845.9,1840.5l-39.8,33.4c-7.7,6.4-19.8-1.1-18.1-11.2l3.1-19.4c2.7-16.7,10.9-31.4,23.5-41.9l39.8-33.4
		c7.7-6.4,19.7,1.1,18,11.2l-3.1,19.5C3866.7,1815.2,3858.4,1829.9,3845.9,1840.5"
        />
        <path
          className="st0"
          d="M3851,1740.8l-37.4,36.1c-7.2,7-19.7,0.4-18.8-9.9l1.8-19.6c1.5-16.8,8.7-32.1,20.5-43.5l37.4-36.1
		c7.2-6.9,19.8-0.3,18.8,10l-1.8,19.6C3870.1,1714.1,3862.8,1729.4,3851,1740.8"
        />
        <path
          className="st0"
          d="M3849.2,1641l-34.8,38.6c-6.7,7.4-19.6,1.7-19.4-8.5l0.3-19.8c0.4-16.8,6.5-32.6,17.4-44.8l34.8-38.6
		c6.7-7.4,19.7-1.7,19.5,8.6l-0.4,19.7C3866.2,1613.1,3860.1,1628.9,3849.2,1641"
        />
        <path
          className="st0"
          d="M3840.4,1541.7l-32,40.9c-6.2,8-19.5,3.2-20-7.1l-1-19.8c-0.8-16.7,4.3-32.9,14.3-45.9l32-40.9
		c6.2-7.9,19.4-3.1,20,7.1l1,19.8C3855.5,1512.6,3850.4,1528.8,3840.4,1541.7"
        />
        <path
          className="st0"
          d="M3824.7,1443.1l-29.1,43.1c-5.6,8.3-19.2,4.4-20.5-5.8l-2.3-19.6c-2-16.7,1.8-33.2,11-46.7l29.1-43
		c5.6-8.3,19.2-4.5,20.4,5.8l2.4,19.6C3837.7,1413.1,3833.8,1429.6,3824.7,1443.1"
        />
        <path
          className="st0"
          d="M3802.1,1346l-26,44.9c-5,8.7-18.9,5.7-20.8-4.3l-3.7-19.4c-3.2-16.5-0.4-33.2,7.8-47.4l26-44.9
		c4.9-8.7,18.9-5.8,20.8,4.3l3.8,19.4C3813,1315,3810.2,1331.8,3802.1,1346"
        />
        <path
          className="st0"
          d="M3772.9,1250.6l-22.8,46.8c-4.3,8.8-18.5,6.9-21-2.9l-5.1-19.1c-4.4-16.3-2.8-33.2,4.3-47.9l22.9-46.7
		c4.3-8.9,18.5-7,21,2.9l5.1,19.1C3781.5,1219,3780,1235.9,3772.9,1250.6"
        />
        <path
          className="st0"
          d="M3737,1157.5l-19.5,48.2c-3.8,9.2-17.9,8.3-21.2-1.5l-6.4-18.7c-5.5-15.9-5.1-32.8,1-48l19.5-48.2
		c3.8-9.2,18-8.3,21.2,1.4l6.4,18.7C3743.5,1125.4,3743.1,1142.3,3737,1157.5"
        />
        <path
          className="st0"
          d="M3694.7,1067l-16.2,49.5c-3,9.4-17.2,9.5-21.2,0.1l-7.6-18.2c-6.6-15.5-7.4-32.5-2.3-47.9l16-49.5
		c3.1-9.5,17.3-9.5,21.3,0l7.7,18.1C3699,1034.7,3699.7,1051.6,3694.7,1067"
        />
        <path
          className="st0"
          d="M3646.2,979.9l-12.6,50.4c-2.3,9.8-16.5,10.8-21.1,1.6l-9-17.7c-7.6-15-9.5-31.8-5.6-47.7l12.6-50.4
		c2.4-9.7,16.6-10.7,21.3-1.5l8.9,17.6C3648.2,947.2,3650.2,964.1,3646.2,979.9"
        />
        <path
          className="st0"
          d="M3591.8,896.3l-9,51.2c-1.7,9.8-15.8,11.9-21.1,3.1l-10.2-17c-8.6-14.5-11.8-31.1-8.9-47.2l9-51.2
		c1.8-9.8,15.7-11.8,21-3.1l10.1,17C3591.4,863.6,3594.6,880.2,3591.8,896.3"
        />
        <path
          className="st0"
          d="M3531.6,816.7l-5.5,51.7c-1,9.9-14.9,12.9-20.7,4.4l-11.3-16.2c-9.6-13.8-14-30.2-12.2-46.4l5.5-51.7
		c1.1-10,14.9-12.9,20.7-4.5l11.3,16.2C3529.1,784.1,3533.3,800.4,3531.6,816.7"
        />
        <path
          className="st0"
          d="M3466,741.4l-1.8,51.9c-0.3,10-14,13.9-20.4,5.9l-12.3-15.4c-10.7-13.2-16.1-29.1-15.5-45.5l1.8-52
		c0.4-10,14-13.9,20.4-5.9l12.4,15.3C3461.2,709.1,3466.7,725.1,3466,741.4"
        />
        <path
          className="st0"
          d="M3395.4,671l1.7,52c0.4,10-12.9,14.8-19.9,7.3l-13.5-14.5c-11.5-12.4-18-28-18.6-44.3l-1.8-52
		c-0.3-10,13-14.8,20.1-7.4l13.3,14.5C3388.3,639,3394.8,654.7,3395.4,671"
        />
        <path
          className="st0"
          d="M3320.1,605.6l5.4,51.7c1,9.9-11.9,15.8-19.4,8.7l-14.5-13.5c-12.3-11.5-19.9-26.7-21.6-42.9l-5.4-51.7
		c-1.1-9.9,11.9-15.7,19.4-8.7l14.4,13.6C3310.7,574.2,3318.3,589.4,3320.1,605.6"
        />
        <path
          className="st0"
          d="M3240.3,545.7l9,51.2c1.7,9.9-10.8,16.5-18.8,10l-15.3-12.4c-13-10.7-21.6-25.2-24.5-41.3l-9-51.2
		c-1.8-9.9,10.8-16.5,18.7-10.1l15.4,12.5C3228.8,515,3237.4,529.6,3240.3,545.7"
        />
        <path
          className="st0"
          d="M3156.5,491.4l12.6,50.4c2.4,9.7-9.5,17.3-18,11.3l-16.1-11.4c-13.8-9.7-23.5-23.6-27.4-39.4l-12.6-50.4
		c-2.4-9.7,9.6-17.2,18.1-11.4l16.1,11.4C3142.8,461.7,3152.6,475.7,3156.5,491.4"
        />
        <path
          className="st0"
          d="M3069.1,443.1l16.1,49.4c3.1,9.5-8.4,17.9-17.2,12.6l-16.9-10.3c-14.4-8.7-25-21.9-30-37.4l-16.1-49.4
		c-3.1-9.5,8.4-17.9,17.1-12.5l16.9,10.3C3053.5,414.4,3064.1,427.6,3069.1,443.1"
        />
        <path
          className="st0"
          d="M2978.7,401.1l19.5,48.1c3.8,9.2-7.1,18.4-16.3,13.7l-17.5-9c-15-7.7-26.5-20.2-32.6-35.3l-19.5-48.2
		c-3.8-9.3,7.1-18.4,16.2-13.7l17.6,9.1C2961.1,373.5,2972.5,386,2978.7,401.1"
        />
        <path
          className="st0"
          d="M2885.4,365.5l22.8,46.7c4.4,8.9-5.7,18.8-15.2,14.8l-18.2-7.9c-15.5-6.6-27.8-18.2-35-32.9l-22.8-46.7
		c-4.3-8.9,5.8-18.8,15.2-14.8l18.1,7.8C2866,339.2,2878.3,350.7,2885.4,365.5"
        />
        <path
          className="st0"
          d="M2790,336.4l26.1,45c4.9,8.7-4.5,19.2-14.2,15.8l-18.6-6.4c-15.9-5.5-29-16.3-37.2-30.4l-26-45
		c-5.1-8.7,4.5-19.2,14.1-15.9l18.6,6.5C2768.7,311.5,2781.8,322.2,2790,336.4"
        />
        <path
          className="st0"
          d="M2692.7,314l29.2,43.1c5.6,8.4-3.2,19.5-13.1,16.8l-19-5.1c-16.3-4.5-30.1-14.3-39.3-27.7l-29-43.2
		c-5.6-8.2,3-19.4,13-16.8l19.1,5.3C2669.7,290.7,2683.6,300.5,2692.7,314"
        />
        <path
          className="st0"
          d="M2594.1,298.5l32,40.9c6.1,7.9-1.8,19.7-11.8,17.6l-19.3-3.8c-16.6-3.3-31-12.1-41.1-25l-32-40.9
		c-6.2-7.8,1.7-19.6,11.8-17.7l19.4,3.9C2569.6,276.8,2584.1,285.6,2594.1,298.5"
        />
        <path
          className="st0"
          d="M2494.8,289.9l34.7,38.6c6.7,7.4-0.4,19.7-10.6,18.4l-19.5-2.3c-16.8-2.2-31.8-9.9-42.8-22l-34.8-38.7
		c-6.6-7.4,0.4-19.7,10.6-18.4l19.6,2.5C2468.7,269.9,2483.7,277.8,2494.8,289.9"
        />
        <path
          className="st0"
          d="M2394.9,288.3l37.4,36.2c7.1,6.9,1,19.6-9.3,19.1l-19.6-1.2c-16.8-0.9-32.4-7.6-44.1-18.9l-37.5-36.1
		c-7.1-6.9-1-19.7,9.3-19.1l19.7,1.1C2367.6,270.3,2383.2,276.9,2394.9,288.3"
        />
        <path
          className="st0"
          d="M2295.3,293.6l39.8,33.5c7.7,6.3,2.3,19.5-7.9,19.7l-19.7,0.3c-16.9,0.3-32.9-5.2-45.3-15.8l-39.9-33.4
		c-7.7-6.4-2.4-19.6,7.9-19.7l19.7-0.3C2266.8,277.6,2282.7,283.1,2295.3,293.6"
        />
        <path
          className="st0"
          d="M2196.3,305.9l42.1,30.5c8,5.8,3.7,19.3-6.5,20.2l-19.7,1.6c-16.8,1.5-33.2-3-46.4-12.6l-42-30.6
		c-8-5.9-3.8-19.4,6.5-20.3l19.7-1.7C2166.7,291.8,2183,296.2,2196.3,305.9"
        />
        <path
          className="st0"
          d="M2098.3,325l44.1,27.5c8.4,5.4,5.1,19.1-5.1,20.7l-19.6,3c-16.6,2.6-33.2-0.7-47.1-9.4l-44.1-27.5
		c-8.5-5.3-5-19.1,5.1-20.7l19.5-3C2067.8,313,2084.4,316.3,2098.3,325"
        />
        <path
          className="st0"
          d="M2001.9,351l45.9,24.3c8.8,4.8,6.4,18.7-3.7,21l-19.2,4.4c-16.5,3.7-33.3,1.6-47.6-6.2l-46-24.4
		c-8.8-4.6-6.3-18.7,3.7-20.8l19.2-4.6C1970.6,341.1,1987.5,343.2,2001.9,351"
        />
        <path
          className="st0"
          d="M1907.5,383.5l47.5,21c9.1,4.2,7.7,18.2-2.1,21.2l-19,5.7c-16.1,4.9-33,4-47.9-2.7l-47.5-21.1
		c-9.1-4.1-7.7-18.2,2.1-21.2l18.9-5.7C1875.7,375.9,1892.6,376.9,1907.5,383.5"
        />
        <path
          className="st0"
          d="M1815.7,422.6l48.9,17.8c9.4,3.4,9,17.6-0.7,21.2l-18.5,7c-15.6,6-32.7,6.3-48,0.6l-48.8-17.7
		c-9.3-3.4-8.9-17.6,0.7-21.3l18.5-7C1783.4,417.2,1800.4,417,1815.7,422.6"
        />
        <path
          className="st0"
          d="M1726.9,468l50,14.4c9.6,2.7,10.2,16.9,0.8,21.3l-17.9,8.2c-15.3,7.1-32.2,8.5-47.8,4l-50.1-14.3
		c-9.5-2.8-10.1-16.9-0.8-21.2l17.9-8.3C1694.3,464.8,1711.2,463.5,1726.9,468"
        />
        <path
          className="st0"
          d="M1641.4,519.4l50.9,10.8c9.8,2.1,11.3,16.1,2.3,21.1l-17.3,9.6c-14.8,8.1-31.5,10.7-47.5,7.3l-50.8-10.8
		c-9.7-2.1-11.4-16.2-2.4-21.1l17.4-9.5C1608.7,518.6,1625.4,516.1,1641.4,519.4"
        />
        <path
          className="st0"
          d="M1559.7,576.8l51.5,7.2c9.8,1.4,12.4,15.3,3.8,20.9l-16.7,10.7c-14.1,9.2-30.6,12.9-46.8,10.6l-51.6-7.2
		c-9.9-1.4-12.3-15.4-3.7-20.9l16.6-10.8C1527,578.2,1543.5,574.5,1559.7,576.8"
        />
        <path
          className="st0"
          d="M1482.2,639.6l51.9,3.6c9.9,0.7,13.5,14.5,5.2,20.6l-15.9,11.8c-13.4,10.2-29.6,15-45.9,13.9l-51.9-3.6
		c-10-0.7-13.5-14.4-5.2-20.6l15.8-11.9C1449.6,643.3,1465.9,638.5,1482.2,639.6"
        />
        <path
          className="st0"
          d="M1409.3,707.6h52.1c9.9,0,14.4,13.5,6.6,20.3l-14.9,12.9c-12.7,11-28.6,17-44.9,17h-52
		c-10,0-14.5-13.5-6.7-20.2l14.9-12.9C1377,713.7,1392.9,707.6,1409.3,707.6"
        />
        <path
          className="st0"
          d="M1341.3,780.8l51.9-3.6c9.9-0.7,15.3,12.4,8.1,19.7l-14.1,13.9c-11.9,11.9-27.3,19-43.5,20.1l-51.9,3.6
		c-10,0.7-15.3-12.5-8-19.7l14-13.9C1309.6,789,1324.9,781.9,1341.3,780.8"
        />
        <path
          className="st0"
          d="M1278.6,858.3l51.5-7.2c9.8-1.4,16.1,11.4,9.3,19.1l-13,14.9c-11.1,12.7-25.9,20.8-42.1,23.1l-51.5,7.3
		c-9.9,1.4-16.1-11.3-9.4-19.1l13-14.8C1247.5,868.8,1262.4,860.5,1278.6,858.3"
        />
        <path
          className="st0"
          d="M1221.4,940.1l50.8-10.8c9.8-2.1,16.9,10.1,10.7,18.3l-11.9,15.8c-10.2,13.4-24.4,22.5-40.4,25.9l-50.8,10.8
		c-9.8,2.1-16.9-10.2-10.7-18.3l12-15.7C1191.2,952.7,1205.5,943.5,1221.4,940.1"
        />
        <path
          className="st0"
          d="M1170,1025.7l50-14.4c9.6-2.8,17.5,9.1,12,17.6l-10.8,16.5c-9.2,14.2-22.8,24.3-38.5,28.8l-50,14.3
		c-9.5,2.7-17.5-9-12-17.6l10.8-16.5C1140.8,1040.3,1154.3,1030.2,1170,1025.7"
        />
        <path
          className="st0"
          d="M1124.9,1114.6l48.9-17.7c9.3-3.4,18.1,7.7,13.1,16.7l-9.6,17.3c-8.3,14.7-21.1,25.8-36.5,31.3l-48.8,17.8
		c-9.3,3.4-18.2-7.7-13.2-16.7l9.7-17.3C1096.7,1131.3,1109.5,1120.2,1124.9,1114.6"
        />
        <path
          className="st0"
          d="M1086,1206.4l47.5-21.1c9.1-4.1,18.6,6.4,14.3,15.8l-8.4,17.8c-7.1,15.2-19.2,27.1-34.1,33.8l-47.5,21.2
		c-9.1,4-18.6-6.5-14.2-15.7l8.4-17.9C1059,1225.1,1071.1,1213.1,1086,1206.4"
        />
        <path
          className="st0"
          d="M1053.6,1300.8l46-24.4c8.8-4.7,19.1,5.2,15.3,14.7l-7.2,18.4c-6.1,15.7-17.3,28.5-31.7,36.1l-45.9,24.4
		c-8.8,4.7-19.1-5.1-15.3-14.7l7-18.5C1028,1321.3,1039.2,1308.6,1053.6,1300.8"
        />
        <path
          className="st0"
          d="M1027.8,1397.3l44.1-27.6c8.4-5.3,19.3,3.9,16.3,13.6l-5.8,18.9c-5.1,16.1-15.3,29.5-29.1,38.2l-44.2,27.5
		c-8.4,5.3-19.3-3.8-16.2-13.6l5.8-18.8C1003.7,1419.4,1014,1405.9,1027.8,1397.3"
        />
        <path
          className="st0"
          d="M1008.9,1495.2l42.1-30.6c8-5.8,19.5,2.5,17.2,12.5l-4.5,19.2c-3.8,16.4-13.2,30.6-26.4,40.2l-42.1,30.5
		c-8,5.9-19.6-2.4-17.2-12.4l4.5-19.2C986.4,1519,995.7,1504.8,1008.9,1495.2"
        />
        <path
          className="st0"
          d="M996.8,1594.2l39.8-33.4c7.6-6.4,19.7,1.1,18.1,11.2l-3.2,19.5c-2.6,16.7-10.9,31.4-23.4,42l-39.8,33.4
		c-7.6,6.4-19.7-1-18-11.1l3.1-19.5C976,1619.5,984.3,1604.7,996.8,1594.2"
        />
        <path
          className="st0"
          d="M991.7,1693.9l37.4-36.2c7.2-6.9,19.7-0.2,18.8,10l-1.7,19.7c-1.5,16.7-8.8,32.1-20.5,43.4l-37.4,36.1
		c-7.2,6.9-19.7,0.3-18.8-9.9l1.8-19.7C972.7,1720.6,979.9,1705.2,991.7,1693.9"
        />
        <path
          className="st0"
          d="M993.5,1793.6l34.8-38.6c6.7-7.3,19.6-1.6,19.4,8.6l-0.5,19.8c-0.3,16.8-6.4,32.6-17.4,44.7l-34.8,38.6
		c-6.6,7.4-19.6,1.7-19.4-8.6l0.4-19.7C976.4,1821.5,982.6,1805.8,993.5,1793.6"
        />
        <path
          className="st0"
          d="M1002.4,1893l32-41c6.2-7.8,19.4-3,20,7.2l1.1,19.8c0.7,16.7-4.3,33-14.3,45.8l-32,41c-6.1,7.9-19.5,3-20-7.2
		l-1-19.7C987.2,1922.1,992.3,1905.8,1002.4,1893"
        />
        <path
          className="st0"
          d="M1018.1,1991.6l29.1-43.1c5.5-8.3,19.2-4.5,20.4,5.7l2.4,19.6c2,16.7-1.9,33.1-11,46.7l-29.1,43.1
		c-5.6,8.3-19.2,4.4-20.4-5.8l-2.4-19.6C1005,2021.6,1009,2005.1,1018.1,1991.6"
        />
        <path
          className="st0"
          d="M1040.6,2088.7l26-45.1c5-8.6,18.9-5.7,20.8,4.4l3.8,19.4c3.1,16.5,0.4,33.2-7.8,47.4l-26,45.1
		c-5.1,8.6-18.9,5.7-20.8-4.4l-3.7-19.4C1029.7,2119.6,1032.5,2102.9,1040.6,2088.7"
        />
        <path
          className="st0"
          d="M1069.9,2184.1l22.8-46.8c4.4-8.9,18.4-7,21,2.9l5,19.1c4.4,16.2,2.8,33.1-4.4,47.8l-22.8,46.7
		c-4.3,8.9-18.5,7-21.1-2.9l-5.1-19.1C1061.1,2215.6,1062.7,2198.8,1069.9,2184.1"
        />
        <path
          className="st0"
          d="M1105.8,2277.2l19.4-48.2c3.8-9.3,17.9-8.3,21.3,1.4l6.4,18.6c5.5,16,5.1,32.9-1.1,48.1l-19.5,48.1
		c-3.7,9.3-17.9,8.3-21.2-1.4l-6.4-18.6C1099.4,2309.3,1099.7,2292.4,1105.8,2277.2"
        />
        <path
          className="st0"
          d="M1148,2367.5l16.1-49.4c3.1-9.6,17.2-9.6,21.2-0.1l7.7,18.2c6.5,15.4,7.4,32.4,2.3,47.9l-16.1,49.5
		c-3.1,9.5-17.3,9.5-21.2,0.1l-7.7-18.2C1143.8,2400,1143,2383.1,1148,2367.5"
        />
        <path
          className="st0"
          d="M1196.5,2454.8l12.6-50.4c2.4-9.8,16.6-10.7,21.2-1.5l9,17.5c7.5,15.1,9.5,31.9,5.6,47.7l-12.7,50.5
		c-2.4,9.6-16.5,10.6-21.1,1.5l-8.9-17.6C1194.6,2487.4,1192.6,2470.6,1196.5,2454.8"
        />
        <path
          className="st0"
          d="M1250.9,2538.3l9.1-51.2c1.8-9.8,15.8-11.8,21.1-3.1l10.2,17c8.6,14.5,11.7,31.2,8.9,47.2l-9,51.2
		c-1.8,9.9-15.8,11.8-21.1,3l-10.1-16.9C1251.3,2571.1,1248.1,2554.4,1250.9,2538.3"
        />
        <path
          className="st0"
          d="M1311,2617.9l5.5-51.7c1-9.9,14.8-12.9,20.8-4.5l11.3,16.2c9.7,13.8,13.9,30.2,12.2,46.4l-5.5,51.7
		c-1,9.9-14.9,12.9-20.7,4.4l-11.3-16.2C1313.7,2650.6,1309.4,2634.2,1311,2617.9"
        />
        <path
          className="st0"
          d="M1376.7,2693.3l1.9-52c0.3-9.9,13.9-13.9,20.4-5.9l12.4,15.4c10.5,13.1,16,29.1,15.4,45.5l-1.8,51.9
		c-0.3,10-13.9,13.9-20.4,5.9l-12.4-15.4C1381.5,2725.5,1376.1,2709.5,1376.7,2693.3"
        />
        <path
          className="st0"
          d="M1447.3,2763.7l-1.8-52c-0.2-10,13-14.8,20-7.3l13.5,14.5c11.4,12.3,18,28,18.6,44.3l1.8,51.9
		c0.3,10-13,14.9-20,7.3l-13.4-14.5C1454.5,2795.6,1447.9,2780,1447.3,2763.7"
        />
        <path
          className="st0"
          d="M1522.7,2829l-5.5-51.7c-1-9.9,11.9-15.8,19.4-8.7l14.4,13.5c12.3,11.5,19.9,26.6,21.6,42.9l5.4,51.7
		c1,9.8-11.9,15.6-19.4,8.7l-14.5-13.6C1532,2860.4,1524.4,2845.3,1522.7,2829"
        />
        <path
          className="st0"
          d="M1602.5,2889l-9.1-51.2c-1.7-9.8,10.8-16.6,18.8-10.1l15.3,12.5c13,10.6,21.6,25.2,24.4,41.3l9.1,51.2
		c1.7,9.8-10.8,16.5-18.7,10.1l-15.4-12.5C1614,2919.6,1605.3,2905.1,1602.5,2889"
        />
        <path
          className="st0"
          d="M1686.2,2943.3l-12.6-50.4c-2.4-9.7,9.7-17.2,18-11.3l16.1,11.3c13.7,9.7,23.4,23.6,27.4,39.5l12.6,50.4
		c2.4,9.7-9.6,17.2-18,11.2l-16.2-11.2C1699.8,2973,1690.1,2959.1,1686.2,2943.3"
        />
        <path
          className="st0"
          d="M1773.6,2991.5l-16.1-49.5c-3.1-9.4,8.3-17.8,17.1-12.5l16.9,10.2c14.3,8.8,25,22,30,37.4l16.1,49.6
		c3.1,9.4-8.4,17.7-17.2,12.5l-16.8-10.3C1789.2,3020.3,1778.6,3007,1773.6,2991.5"
        />
        <path
          className="st0"
          d="M1864.1,3033.5l-19.5-48.1c-3.8-9.3,7.1-18.4,16.3-13.8l17.5,9c15,7.6,26.6,20.2,32.6,35.3l19.5,48.2
		c3.8,9.2-7,18.4-16.2,13.7l-17.6-9C1881.7,3061.2,1870.2,3048.8,1864.1,3033.5"
        />
        <path
          className="st0"
          d="M1957.3,3069.2l-22.8-46.7c-4.4-8.9,5.7-18.8,15.2-14.9l18.1,7.8c15.5,6.7,27.8,18.3,35,32.9l22.8,46.7
		c4.3,8.9-5.8,18.8-15.2,14.8l-18.1-7.8C1976.8,3095.5,1964.4,3083.9,1957.3,3069.2"
        />
        <path
          className="st0"
          d="M2052.8,3098.3l-26-45c-5-8.7,4.4-19.2,14.2-15.8l18.6,6.4c16,5.6,29.1,16.3,37.2,30.4l26,45
		c5,8.7-4.5,19.3-14.2,15.9l-18.5-6.5C2074,3123.2,2060.9,3112.4,2052.8,3098.3"
        />
        <path
          className="st0"
          d="M2150,3120.6l-29.1-43c-5.6-8.4,3.2-19.6,13.1-16.9l19,5.1c16.3,4.4,30.2,14.3,39.3,27.8l29.1,43.1
		c5.6,8.2-3.1,19.4-13,16.8l-19.1-5.2C2172.9,3143.9,2159.1,3134.2,2150,3120.6"
        />
        <path
          className="st0"
          d="M2248.6,3136.1l-32-40.9c-6.2-7.9,1.7-19.7,11.8-17.7l19.4,3.8c16.5,3.2,31,12.1,41.1,24.9l32,40.9
		c6.1,7.9-1.8,19.6-11.9,17.7l-19.3-3.8C2273.1,3157.8,2258.6,3149.1,2248.6,3136.1"
        />
        <path
          className="st0"
          d="M2348,3144.8l-34.8-38.6c-6.7-7.4,0.4-19.8,10.6-18.4l19.6,2.4c16.7,2.1,31.8,9.9,42.7,22.1l34.8,38.6
		c6.6,7.4-0.3,19.7-10.6,18.4l-19.5-2.5C2374,3164.6,2358.9,3156.9,2348,3144.8"
        />
        <path
          className="st0"
          d="M2447.8,3146.4l-37.4-36.2c-7.2-6.9-1.1-19.6,9.2-19.1l19.7,1.1c16.9,0.9,32.4,7.6,44.2,18.9l37.4,36.2
		c7.2,6.9,1,19.7-9.2,19.1l-19.7-1.1C2475.1,3164.4,2459.6,3157.7,2447.8,3146.4"
        />
        <path
          className="st0"
          d="M2547.4,3141.1l-39.8-33.5c-7.7-6.4-2.4-19.5,7.8-19.6l19.7-0.3c16.8-0.3,32.8,5.3,45.4,15.9l39.9,33.4
		c7.6,6.4,2.4,19.6-7.9,19.7l-19.7,0.2C2575.9,3157.1,2560,3151.5,2547.4,3141.1"
        />
        <path
          className="st0"
          d="M2646.5,3128.8l-42.1-30.6c-8-5.8-3.7-19.4,6.6-20.2l19.7-1.6c16.7-1.4,33.1,3,46.3,12.7l42.2,30.5
		c8,5.9,3.7,19.3-6.6,20.2l-19.7,1.7C2676.1,3142.8,2659.7,3138.4,2646.5,3128.8"
        />
        <path
          className="st0"
          d="M2744.4,3109.7l-44.1-27.7c-8.5-5.1-5.1-19,5-20.5l19.5-3c16.6-2.5,33.3,0.7,47.2,9.5l44.1,27.5
		c8.5,5.3,5.1,19.1-5.1,20.7l-19.5,3C2774.9,3121.6,2758.4,3118.3,2744.4,3109.7"
        />
        <path
          className="st0"
          d="M2840.9,3083.7l-45.9-24.4c-8.8-4.8-6.3-18.7,3.6-21l19.2-4.4c16.5-3.7,33.3-1.6,47.8,6l45.9,24.4
		c8.8,4.7,6.4,18.7-3.6,20.9l-19.3,4.4C2872.1,3093.5,2855.3,3091.5,2840.9,3083.7"
        />
        <path
          className="st0"
          d="M2935.2,3051.2l-47.5-21.2c-9.1-4-7.7-18.1,2.1-21.1l18.9-5.7c16.1-4.9,33-3.9,48,2.7l47.5,21.1
		c9.1,4.2,7.7,18.2-2.1,21.2l-18.9,5.7C2967,3058.8,2950,3057.8,2935.2,3051.2"
        />
        <path
          className="st0"
          d="M3027,3012.1l-48.9-17.9c-9.4-3.4-8.9-17.5,0.6-21.2l18.5-7c15.8-6,32.7-6.2,48-0.6l48.8,17.7
		c9.4,3.4,8.9,17.7-0.6,21.3l-18.5,7C3059.3,3017.5,3042.3,3017.7,3027,3012.1"
        />
        <path
          className="st0"
          d="M3115.9,2966.7l-50-14.4c-9.5-2.7-10.1-16.9-0.9-21.3l18-8.2c15.3-7.1,32.2-8.4,47.9-4l50,14.3
		c9.5,2.8,10.1,17,0.8,21.3l-17.9,8.3C3148.5,2969.9,3131.6,2971.2,3115.9,2966.7"
        />
        <path
          className="st0"
          d="M3201.3,2915.2l-50.8-10.8c-9.8-2.1-11.3-16.2-2.3-21.2l17.3-9.5c14.7-8.1,31.5-10.7,47.5-7.3l50.9,10.8
		c9.8,2.1,11.2,16.1,2.3,21.2l-17.4,9.5C3234.1,2916,3217.3,2918.6,3201.3,2915.2"
        />
        <path
          className="st0"
          d="M3283.1,2858l-51.6-7.3c-9.9-1.4-12.4-15.3-3.7-20.9l16.6-10.7c14.1-9.1,30.7-12.9,46.8-10.7l51.5,7.3
		c9.8,1.4,12.4,15.3,3.8,20.8l-16.6,10.8C3315.7,2856.5,3299.2,2860.2,3283.1,2858"
        />
        <path
          className="st0"
          d="M3360.5,2795.1l-51.9-3.7c-9.9-0.7-13.4-14.3-5.1-20.6l15.8-11.9c13.4-10,29.7-15,46-13.8l51.9,3.6
		c10,0.7,13.5,14.5,5.2,20.6l-15.9,11.9C3393.1,2791.4,3376.8,2796.2,3360.5,2795.1"
        />
        <polygon
          className="st0"
          points="2298.7,571.6 2374.6,517 2345.3,427.4 2420.7,482.7 2496.9,427.1 2467.6,515.9 2544,571.2 
		2450.4,570.8 2421.5,660.5 2393,571.4 	"
        />
        <polygon
          className="st0"
          points="1869.6,705.8 1918.9,626.2 1857.4,554.7 1948.3,576.9 1997.4,496.4 2004.3,589.7 2096,611.5 
		2009.4,646.9 2017.1,740.9 1956.6,669.5 	"
        />
        <polygon
          className="st0"
          points="1524.5,993.9 1539.6,901.6 1455.4,859 1547.9,844.8 1562.4,751.6 1604.5,835.2 1697.6,820.2 
		1631.2,886 1674.2,969.9 1591,927.1 	"
        />
        <polygon
          className="st0"
          points="1315.9,1392.2 1294.5,1301.2 1200.5,1294 1280.5,1245.5 1258.2,1153.8 1329.1,1214.9 1409.4,1165.4 
		1373.2,1251.7 1445,1312.7 1351.8,1305 	"
        />
        <polygon
          className="st0"
          points="1275.6,1840 1221,1764.1 1131.4,1793.4 1186.7,1718 1131.1,1641.8 1219.9,1671.1 1275.2,1594.7 
		1274.8,1688.3 1364.5,1717.2 1275.4,1745.7 	"
        />
        <polygon
          className="st0"
          points="1409.8,2269.1 1330.3,2219.8 1258.7,2281.3 1281,2190.4 1200.4,2141.3 1293.7,2134.4 1315.5,2042.7 
		1350.9,2129.3 1444.9,2121.6 1373.5,2182.1 	"
        />
        <polygon
          className="st0"
          points="1697.9,2614.2 1605.6,2599.1 1563,2683.3 1548.8,2590.8 1455.6,2576.3 1539.2,2534.2 1524.2,2441.1 
		1590,2507.6 1673.9,2464.5 1631.1,2547.7 	"
        />
        <polygon
          className="st0"
          points="2096.2,2822.8 2005.1,2844.2 1998,2938.2 1949.5,2858.2 1857.8,2880.5 1918.9,2809.6 1869.4,2729.3 
		1955.7,2765.5 2016.7,2693.7 2009,2786.9 	"
        />
        <polygon
          className="st0"
          points="2544,2863 2468.1,2917.7 2497.4,3007.3 2422,2952 2345.8,3007.6 2375.1,2918.7 2298.7,2863.5 
		2392.3,2863.9 2421.2,2774.2 2449.7,2863.3 	"
        />
        <polygon
          className="st0"
          points="2973.1,2728.9 2923.8,2808.4 2985.3,2880 2894.4,2857.7 2845.3,2938.3 2838.4,2845 2746.7,2823.2 
		2833.3,2787.8 2825.6,2693.8 2886,2765.2 	"
        />
        <polygon
          className="st0"
          points="3318.2,2440.8 3303.1,2533.1 3387.3,2575.7 3294.8,2589.9 3280.3,2683.1 3238.2,2599.5 3145.1,2614.5 
		3211.6,2548.7 3168.5,2464.7 3251.7,2507.6 	"
        />
        <polygon
          className="st0"
          points="3526.8,2042.5 3548.2,2133.5 3642.2,2140.7 3562.2,2189.2 3584.5,2280.9 3513.6,2219.8 3433.3,2269.2 
		3469.5,2183 3397.7,2121.9 3490.9,2129.7 	"
        />
        <polygon
          className="st0"
          points="3567,1594.7 3621.7,1670.6 3711.3,1641.3 3656,1716.7 3711.6,1792.9 3622.7,1763.6 3567.5,1840 
		3567.9,1746.4 3478.2,1717.5 3567.3,1689 	"
        />
        <polygon
          className="st0"
          points="3432.9,1165.6 3512.4,1214.8 3584,1153.4 3561.7,1244.3 3642.3,1293.4 3549,1300.3 3527.2,1392 
		3491.8,1305.4 3397.8,1313.1 3469.2,1252.6 	"
        />
        <polygon
          className="st0"
          points="3144.8,820.5 3237.1,835.6 3279.7,751.4 3293.9,843.9 3387.1,858.4 3303.5,900.5 3318.5,993.6 
		3252.7,927.1 3168.7,970.2 3211.6,887 	"
        />
        <polygon
          className="st0"
          points="2746.5,611.9 2837.6,590.5 2844.7,496.5 2893.2,576.5 2984.9,554.2 2923.8,625.1 2973.3,705.4 
		2887,669.2 2825.9,741 2833.7,647.8 	"
        />
        <path
          className="st0"
          d="M2421.4,999.3c-395.9,0-718,322.1-718,718c0,395.9,322.1,718,718,718c395.9,0,718-322.1,718-718
		C3139.4,1321.4,2817.3,999.3,2421.4,999.3 M2421.4,2456.9c-407.8,0-739.6-331.8-739.6-739.6c0-407.9,331.8-739.6,739.6-739.6
		c407.8,0,739.6,331.8,739.6,739.6C3161,2125.2,2829.2,2456.9,2421.4,2456.9"
        />
        <path
          className="st0"
          d="M2421.4,743.7c-536.8,0-973.6,436.7-973.6,973.6c0,536.8,436.8,973.5,973.6,973.5
		c536.8,0,973.6-436.7,973.6-973.5C3395,1180.5,2958.2,743.7,2421.4,743.7 M2421.4,2713.2c-549.1,0-995.9-446.8-995.9-995.9
		c0-549.1,446.7-995.9,995.9-995.9c549.1,0,995.9,446.8,995.9,995.9C3417.3,2266.4,2970.5,2713.2,2421.4,2713.2"
        />
        <polygon
          className="st0"
          points="2233.7,2575.3 2263,2582.3 2257.8,2604.6 2173.7,2584.7 2179,2562.4 2208.8,2569.4 2231.4,2474.1 
		2256.2,2480 	"
        />
        <path
          className="st0"
          d="M2108.4,2583c-2.6,6.5-9.2,9.6-15.3,7.2c-5.7-2.3-8.2-9.1-5.6-15.6c2.4-6.2,8.9-9.6,14.7-7.2
		C2108.4,2569.9,2110.9,2576.9,2108.4,2583 M2076.2,2570.2c-2.6,6.5-9.1,9.7-15.1,7.3c-5.9-2.4-8.4-9.1-5.8-15.6
		c2.5-6.2,8.9-9.6,14.9-7.2C2076.4,2557.1,2078.6,2564,2076.2,2570.2 M2108.9,2562.6l25.7-64.6c7.7-19.3,4.8-31.9-7.3-36.7
		c-12.4-4.9-22.9,1.7-30.8,21.5l-25.7,64.6l-23.6-9.4l25.1-63c13.8-34.6,36.7-44.6,64-33.7c26.3,10.5,35.6,32.3,21.3,68.2
		l-24.9,62.6L2108.9,2562.6z"
        />
        <path
          className="st0"
          d="M2005.4,2455.2l-8.6-5c-10.9-6.4-20.8-4.4-26.2,4.7c-5.6,9.6-2.4,18,7.6,24c5.3,3.1,8.6,4.4,10.4,5
		L2005.4,2455.2z M2000.8,2512.8c-7.8-2.9-18.8-8.1-30.4-15c-14.4-8.5-23.1-16.7-26.5-26.6c-2.8-8.3-1.7-17.5,3.8-27.1
		c7.8-13.3,22-17.2,32.2-15.6l0.2-0.5c-5-6.9-4.7-16-1.5-27.1c3.9-13.5,8.8-28.9,9.3-34l22.4,13.2c-0.2,3.9-2.9,13.7-7.5,28.3
		c-5,14.5-2.9,20.5,5.9,25.9l6.6,3.9l24-41l21.7,12.8L2000.8,2512.8z"
        />
        <path
          className="st0"
          d="M1890.2,2445.6l-19.6-15.7l33.4-41.7l-0.4-0.4c-4.9,2.1-9.7,3.8-14.3,5.6l-45,15.4l-24.3-19.5l61.2-16.9
		l12.9-78.7l23.1,18.6l-11.1,57.9l15.5-3.9l24.7-30.8l19.6,15.8L1890.2,2445.6z"
        />
        <path
          className="st0"
          d="M1773.5,2342.9l85.7-85.3l18,18.1l-85.8,85.3L1773.5,2342.9z M1776.9,2373.5c-4.9,4.9-12.4,5.1-17,0.5
		c-4.5-4.5-4.1-11.8,0.9-16.7c4.6-4.5,12.1-5.2,16.5-0.6C1782.1,2361.4,1781.6,2368.9,1776.9,2373.5"
        />
        <path
          className="st0"
          d="M1818.8,2212.1l-38.8,30.8l-33.8,72.3l-18-22.8l15.6-27.1c4.7-8.2,8.4-14.1,12.8-21.2l-0.2-0.3
		c-7.5,2.8-14.7,5-23.4,7.8l-29.8,9.1l-17.7-22.4l78.3-14.8l39.5-31.3L1818.8,2212.1z"
        />
        <polygon
          className="st0"
          points="1689.1,2110.8 1710.1,2146.4 1734.8,2131.8 1711.3,2092 1730.6,2080.6 1767.1,2142.4 1663,2203.9 
		1627.7,2144.1 1647,2132.7 1669.3,2170.5 1690.9,2157.8 1669.9,2122.1 	"
        />
        <path
          className="st0"
          d="M1669.3,1938.8c3.9,3.6,10,12.6,14.5,25.5c13,36.7-4.8,64.3-37.2,75.8c-38.8,13.8-69.6-4.3-81-36.4
		c-4.4-12.4-5.1-22.8-4.2-27.9l22.2-2.3c-0.5,5.6-0.1,13.1,2.9,21.6c6.7,19,24.3,29.5,49.6,20.4c22.8-8.1,32.7-25.8,25.1-47.2
		c-2.5-7.2-7.1-14.6-10.8-18.6L1669.3,1938.8z"
        />
        <path
          className="st0"
          d="M1541.5,1908.3l68.4-13.1c20.5-3.9,29.5-13.1,27-25.9c-2.5-13.1-13.8-18.4-34.7-14.4l-68.3,13.1l-4.8-24.9
		l66.6-12.8c36.6-7,57.4,6.9,62.9,35.7c5.4,27.8-8.1,47.4-45.9,54.6l-66.3,12.7L1541.5,1908.3z"
        />
        <path
          className="st0"
          d="M1595.4,1694.1c-14.5,0.7-32.1,1.5-49.6,1.8v0.6c15.4,3.2,32.7,7.6,46.9,11.7l47.3,12.9l0.4,19.8l-46.6,12.8
		c-14.1,3.9-31.3,8.1-47,11v0.3c16.3,0.4,35,0.6,50,1.1l45.9,1.2l0.4,23.5l-120.9-5.1l-0.5-33.8l40.2-11.7
		c13.9-3.8,28.9-7.5,43-10.3l0-0.4c-14-2.9-30-6.5-43.5-10l-40.3-11.3l-0.5-33.2l120.7-8.2l0.4,24.8L1595.4,1694.1z"
        />
        <polygon
          className="st0"
          points="1529.8,1590.4 1575.6,1597.9 1582.4,1556.7 1536.6,1549.1 1540.7,1524.1 1660,1543.8 1655.9,1568.7 
		1606,1560.6 1599.1,1601.8 1649,1610 1644.9,1635.2 1525.6,1615.5 	"
        />
        <path
          className="st0"
          d="M1562,1447.5l65.9,22.4c19.7,6.7,32.1,3.1,36.3-9.2c4.3-12.7-2.8-22.8-23.1-29.7l-65.9-22.4l8.2-24l64.2,21.8
		c35.3,12,46.5,34.3,37.1,62.1c-9.1,26.9-30.4,37.2-67,24.9l-63.8-21.7L1562,1447.5z"
        />
        <path
          className="st0"
          d="M1663.9,1338.3l4.6-8.8c5.8-11.2,3.3-21.1-6.2-25.9c-9.9-5.1-18-1.5-23.6,8.8c-2.8,5.5-4,8.8-4.5,10.6
		L1663.9,1338.3z M1606.2,1336.7c2.5-7.9,7.2-19.2,13.4-31.2c7.7-14.8,15.4-23.9,25.2-27.9c8.2-3.2,17.4-2.6,27.2,2.6
		c13.7,7.1,18.4,20.9,17.3,31.3l0.5,0.2c6.6-5.4,15.8-5.5,27-2.9c13.7,3.2,29.4,7.3,34.5,7.6l-12,23.1c-3.9,0-13.9-2.1-28.6-6
		c-14.8-4.3-20.6-1.9-25.6,7.2l-3.5,6.8l42.2,21.9l-11.6,22.3L1606.2,1336.7z"
        />
        <path
          className="st0"
          d="M1680.5,1205.2l100.4,67.1l-14.2,21.2l-100.4-67.1L1680.5,1205.2z M1651.2,1214.6c-5.8-3.9-7.4-11.2-3.8-16.6
		c3.5-5.3,10.7-6.3,16.5-2.4c5.4,3.5,7.5,10.8,4,16.1C1664.1,1217.2,1656.5,1218.2,1651.2,1214.6"
        />
        <path
          className="st0"
          d="M1817.8,1223.4l-37.7-31.9l-77.4-18.9l18.7-22.2l29.5,10c9,3,15.4,5.4,23.3,8.3l0.2-0.2
		c-4.2-6.8-7.8-13.3-12.2-21.4l-14.9-27.4l18.4-21.8l29.9,73.8l38.5,32.5L1817.8,1223.4z"
        />
        <polygon
          className="st0"
          points="1891.6,1076.1 1860.9,1103.7 1880,1125.1 1914.4,1094.2 1929.3,1110.8 1876,1158.7 1795.3,1069 
		1846.9,1022.6 1861.9,1039.3 1829.3,1068.6 1846,1087.2 1876.8,1059.6 	"
        />
        <polygon
          className="st0"
          points="1915.7,999.1 1890.8,1016.2 1877.8,997.3 1949,948.4 1962,967.4 1936.7,984.7 1992.2,1065.5 
		1971.1,1079.9 	"
        />
        <path
          className="st0"
          d="M2006.2,917.1l57.3,106.5l-22.5,12.2l-57.3-106.5L2006.2,917.1z M1975.8,911.7c-3.3-6.2-1.3-13.4,4.4-16.5
		c5.6-3,12.4-0.5,15.7,5.6c3.1,5.7,1.5,13.1-4,16C1985.9,920,1978.8,917.4,1975.8,911.7"
        />
        <path
          className="st0"
          d="M2094.2,876.4l23.8-8.1l17.2,50.6l0.4-0.2c0.9-5.3,2-10.1,3-15l11.3-46.2l29.5-10l-18.7,60.6l59.5,53.1
		l-28.1,9.6l-42.8-40.5l-5.1,15.1l12.7,37.3l-23.8,8.1L2094.2,876.4z"
        />
        <path
          className="st0"
          d="M2270,809.1c-1.2-6.9,2.6-13,9-14.2c6.2-1.1,11.9,3.4,13.1,10.3c1.1,6.5-2.5,12.8-8.9,14
		C2276.7,820.4,2271.1,815.7,2270,809.1 M2235.8,815.1c-1.2-6.9,2.8-13.1,9.2-14.2c6-1,11.8,3.4,13,10.3c1.1,6.5-2.5,12.8-8.7,13.9
		C2242.7,826.3,2237,821.6,2235.8,815.1 M2246.2,832.8l12,68.5c3.6,20.5,12.7,29.6,25.5,27.4c13.2-2.3,18.6-13.4,14.9-34.5
		l-12.1-68.5l25-4.3l11.7,66.7c6.5,36.7-7.7,57.2-36.6,62.2c-27.9,4.9-47.2-8.9-53.9-46.8l-11.7-66.4L2246.2,832.8z"
        />
        <polygon
          className="st0"
          points="2363.3,816.8 2388.8,816 2391.9,913.9 2436.6,912.4 2437.4,935.4 2367.1,937.7 	"
        />
        <polygon
          className="st0"
          points="2483.9,840.3 2453.8,837.7 2455.7,814.9 2541.9,822.1 2540,845 2509.4,842.4 2501.3,940 2475.8,937.9 
			"
        />
        <path
          className="st0"
          d="M2640.3,822.2c1.6-6.8,7.5-10.9,13.8-9.5c6.2,1.5,9.7,7.8,8.1,14.6c-1.6,6.4-7.4,10.8-13.7,9.2
		C2642.1,835.1,2638.8,828.6,2640.3,822.2 M2606.6,814.3c1.6-6.8,7.7-10.9,14-9.4c6,1.4,9.5,7.8,7.9,14.5
		c-1.5,6.5-7.3,10.8-13.5,9.4C2608.5,827.2,2605,820.7,2606.6,814.3 M2609.2,834.6l-15.9,67.7c-4.8,20.2-0.1,32.2,12.6,35.1
		c13,3.1,22.4-5.1,27.3-25.8l15.9-67.7l24.7,5.8l-15.5,66c-8.5,36.3-29.6,49.5-58.2,42.8c-27.6-6.5-40-26.7-31.1-64.2l15.4-65.6
		L2609.2,834.6z"
        />
        <path
          className="st0"
          d="M2727.4,925.3l9.3,3.8c11.8,4.8,21.3,1.2,25.2-8.6c4.1-10.3-0.3-18.1-11-22.6c-5.7-2.3-9.2-3.2-11-3.5
		L2727.4,925.3z M2723.5,867.7c8.1,1.7,19.8,5.3,32.3,10.3c15.4,6.2,25.2,13.1,30.1,22.4c4,7.8,4.3,17,0.1,27.3
		c-5.8,14.3-19.2,20.3-29.5,20.2l-0.2,0.5c6,6.1,7.1,15.2,5.5,26.5c-1.9,14-4.5,29.9-4.2,35.1l-24.1-9.8c-0.4-3.8,0.8-14,3.3-29
		c2.8-15.1-0.1-20.8-9.6-24.7l-7.2-2.9l-17.8,44l-23.3-9.4L2723.5,867.7z"
        />
        <path
          className="st0"
          d="M2840.1,1057l36.5-120.6l23.2,15.4l-16.7,50.1c-4.7,14.1-9.4,27.5-15.5,41.6l0.4,0.2
		c10.4-10.5,21.2-20.5,32-29.9l40.4-35.1l22.5,14.9l-98.1,79.8L2840.1,1057z"
        />
        <polygon
          className="st0"
          points="2999.1,1116.3 2968.2,1088.9 2949.1,1110.3 2983.7,1141 2968.9,1157.8 2915.2,1110.3 2995.3,1019.8 
		3047.2,1065.8 3032.3,1082.6 2999.5,1053.5 2982.9,1072.3 3013.8,1099.7 	"
        />
        <polygon
          className="st0"
          points="3108.3,1167.1 3089.7,1143.3 3107.8,1129.2 3161,1197.2 3142.9,1211.3 3124,1187.1 3046.7,1247.3 
		3031.1,1227.2 	"
        />
        <path
          className="st0"
          d="M3197.8,1255.5l-60.5,34.2c-18.1,10.3-23.7,21.8-17.3,33.2c6.6,11.6,19,13,37.5,2.6l60.5-34.3l12.5,22.1
		l-58.9,33.4c-32.4,18.3-56.5,11.8-71-13.8c-14-24.7-7.5-47.5,26-66.5l58.7-33.2L3197.8,1255.5z"
        />
        <path
          className="st0"
          d="M3211.1,1404l3.5,9.4c4.5,11.9,13.5,16.5,23.4,12.7c10.4-3.9,13.2-12.5,9.2-23.4c-2.1-5.8-3.9-8.9-4.9-10.5
		L3211.1,1404z M3250.9,1362.1c4.2,7.1,9.5,18.1,14.3,30.8c5.9,15.6,7.5,27.5,3.9,37.4c-3,8.2-9.6,14.7-20,18.6
		c-14.5,5.4-27.9-0.3-34.9-8l-0.5,0.2c-0.4,8.6-6.5,15.4-15.8,22c-11.6,8.1-25.1,16.9-28.7,20.7l-9.2-24.4
		c2.5-2.9,10.8-8.9,23.6-17.3c13-8.1,15.2-14.1,11.7-23.9l-2.7-7.2l-44.5,16.8l-8.9-23.6L3250.9,1362.1z"
        />
        <path
          className="st0"
          d="M3312.1,1477.8c6.8-1.7,13.3,2,14.8,8.3c1.6,6.2-2.4,12.2-9.2,13.9c-6.2,1.6-13-1.7-14.6-7.8
		C3301.4,1485.7,3305.8,1479.4,3312.1,1477.8 M3299.4,1505.9l-117.1,29.7l-6.2-24.7l117-29.7L3299.4,1505.9z"
        />
        <polygon
          className="st0"
          points="3203.9,1560.3 3293.6,1601.7 3294.3,1601.6 3287.4,1553.5 3309.8,1550.3 3321.4,1631.1 3305.7,1633.3 
		3217.3,1593 3216.6,1593 3224.2,1645.8 3201.8,1649 3189.3,1562.4 	"
        />
        <path
          className="st0"
          d="M3249,1772.5c14.5-0.2,32.1-0.3,49.7,0.1v-0.6c-15.4-3.8-32.5-8.9-46.6-13.5l-46.8-14.7l0.4-19.9l47.1-10.9
		c14.2-3.3,31.5-6.8,47.4-9.1l0-0.4c-16.3-1-35-2-50-3.2l-45.9-3l0.5-23.5l120.7,9.9l-0.7,33.8l-40.6,10.1
		c-14,3.2-29.2,6.3-43.4,8.5v0.4c13.9,3.5,29.8,7.7,43.1,11.7l39.9,12.9l-0.8,33.1l-121,3.4l0.6-24.8L3249,1772.5z"
        />
        <path
          className="st0"
          d="M3254.3,1912l-2,8.1c-3.3,13,0.7,21.4,9.4,23.5c8.9,2.3,15.2-2.9,18-14.1c1.3-5.3,1.8-8.5,2-10.7L3254.3,1912z
		 M3202.3,1898.9c-1,2.3-1.8,5.2-2.8,9.4c-2.8,11.2-0.8,22.2,11.6,25.3c11.9,3,19.1-5.7,22.2-18l2.1-8.4L3202.3,1898.9z
		 M3305.4,1898.8c-0.2,6.8-2.5,20.2-5.6,32.5c-3.8,15.1-7.7,23.9-14.7,30.6c-6.3,6.5-15.7,10-26.3,7.3
		c-10.4-2.7-18.7-10.8-20.5-24.3l-0.4-0.1c-6.8,11.5-19.2,18.2-34.3,14.4c-10.6-2.7-17.8-9.3-22-17.6c-4.8-9.7-5.3-23.9,0.2-45.6
		c3-12.1,6.2-20.9,8.5-26.2L3305.4,1898.8z"
        />
        <path
          className="st0"
          d="M3186.8,2047.3l26.3,3.5c7.4,0.9,16.4,2.5,23.7,3.7l0.2-0.3c-6-4.3-13.8-9.4-19.6-13.7l-21.1-16.1
		L3186.8,2047.3z M3178.9,2013.2l-25.5-19.4l10.2-24.3l98.2,78.3l-12.9,30.8L3124,2064l10.6-25.2l32,3.9L3178.9,2013.2z"
        />
        <path
          className="st0"
          d="M3215.1,2149.2l-13,21.6l-45.7-27.7l-0.2,0.4c2.7,4.6,4.9,9.1,7.4,13.5l21.2,42.6l-16.1,26.7l-24.8-58.4
		l-79.6-2.4l15.3-25.4l58.8,3.5l-5.8-14.9l-33.8-20.4l13-21.5L3215.1,2149.2z"
        />
        <path
          className="st0"
          d="M3052,2262l24.1,11.2c6.8,3.1,14.9,7.3,21.5,10.7l0.2-0.3c-4.4-5.9-10.3-13.1-14.5-19l-15.3-21.7L3052,2262z
		 M3054.8,2226.9l-18.6-26.1l16.9-20.2l70.4,104.2l-21.5,25.5l-114.9-51.3l17.6-20.9l29.3,13.4L3054.8,2226.9z"
        />
        <path
          className="st0"
          d="M2968.5,2277.4l79,91.3l-22.4,19.4l-46.7-18.2c-13.4-5.3-28.2-12.3-41-19.3l-0.4,0.4
		c11.7,11,22.7,23,34.6,36.7l23.1,26.7l-17.7,15.2l-79-91.2l20.2-17.5l48.7,19.5c13.5,5.4,29.2,12.4,42.7,19.5l0.3-0.4
		c-11-11.6-22.4-24.3-35.2-39.2l-23.8-27.5L2968.5,2277.4z"
        />
        <polygon
          className="st0"
          points="2934.3,2460.3 2912.8,2474.1 2860.2,2391.6 2822.5,2415.7 2810.2,2396.3 2869.3,2358.5 	"
        />
        <polygon
          className="st0"
          points="2817.4,2528 2763.1,2420.1 2785.9,2408.6 2840.2,2516.5 	"
        />
        <path
          className="st0"
          d="M2742.8,2591.9c-1.8-3.5-5.6-6.7-12.1-4.4c-6.6,2.4-7.8,7-7.1,11.3l-12.2,4.4c-4.1-12.4-0.6-23.8,14.3-29.2
		c15.5-5.6,25,1.1,29.6,13.3L2742.8,2591.9z M2645.1,2472.9c6.4-5.3,19-14.1,33-19.1c19.3-7,35.1-6.8,48.5-0.1
		c13.2,6.2,23.9,19.2,29.8,35.9c13.5,37.8-4.3,68.6-39,81.1c-13.6,4.9-25.2,5.9-31.3,5l-2.4-22.4c6.8,0.6,14.8,0.2,26.4-4
		c19.9-7.2,30.6-24.7,21.7-49.3c-8.4-23.4-27.1-32.3-46.6-25.3c-5.5,2-9.7,4.2-11.2,6l8.5,23.7l16.3-5.9l7.2,20l-39.3,14.2
		L2645.1,2472.9z"
        />
        <polygon
          className="st0"
          points="2612.4,2598.4 2585.6,2480.7 2610.4,2475 2637.3,2592.7 	"
        />
        <path
          className="st0"
          d="M2421.4,2538.6c-19.3,0-35,15.6-35,34.9s15.7,34.9,35,34.9c19.3,0,35-15.7,35-34.9
		S2440.7,2538.6,2421.4,2538.6"
        />
        <polygon
          className="st0"
          points="2267.4,1240.9 2420,1088.9 2572,1241.6 2364.2,1449.7 2325.4,1411.3 2494.2,1241.6 2420,1165.6 
		2345.8,1241.6 2405.3,1302 2367.1,1341.7 	"
        />
        <polygon
          className="st0"
          points="2037.7,1473.7 2190.3,1320.3 2399.7,1532.2 2360.8,1570.7 2189.4,1397 2115,1473.7 2175.1,1534.1 
		2136.6,1573.6 	"
        />
        <polygon
          className="st0"
          points="2653,1320.3 2805.7,1473.6 2594.8,1684 2556.5,1644.9 2729.4,1472.6 2653,1398 2592.9,1458.4 
		2553.6,1419.7 	"
        />
        <polygon
          className="st0"
          points="2188.6,1851.1 2036,1697.7 2246.8,1487.4 2285.1,1526.5 2112.3,1698.7 2188.6,1773.4 2248.7,1713.1 
		2288,1751.7 	"
        />
        <polygon
          className="st0"
          points="2801.9,1698.6 2649.3,1852 2439.9,1640.1 2478.8,1601.6 2650.2,1775.2 2724.6,1698.6 2664.5,1638.2 
		2703,1598.7 	"
        />
        <polygon
          className="st0"
          points="2333.3,1642.2 2479.4,1496 2517.5,1534.9 2372,1681.7 	"
        />
        <polygon
          className="st0"
          points="2587,1559.2 2441.5,1412.4 2480.3,1374.1 2626.4,1520.2 	"
        />
        <polygon
          className="st0"
          points="2217.7,1637.8 2257.2,1599.9 2409.4,1753.8 2409.4,2087.2 2356.4,2140.4 2317.8,2101.6 2355,2063.8 
		2355,1776.7 	"
        />
        <polygon
          className="st0"
          points="2481.6,1714.9 2520.2,1753.8 2489,1785.5 2489,2068 2654.3,2233 2729.2,2156.9 2654.3,2082.5 
		2600.2,2138.1 2561.1,2098.8 2654.7,2005.3 2806.9,2158.2 2654.7,2310.7 2435,2090.9 2435,1762.2 	"
        />
        <polygon
          className="st0"
          points="2037.5,2157.7 2189.3,2005.5 2422.7,2238.3 2485.9,2174.2 2524.1,2213.7 2422.7,2316.1 2189,2081.3 
		2115,2157.4 2190.2,2233.5 2248.6,2174.2 2286.2,2214.3 2189.6,2310.7 	"
        />
      </g>
    </svg>
  );
};

export default Ktb;
